module.exports = __webpack_public_path__ + "img/估价小背景@2x.1e6b5e81.png";